import { render, staticRenderFns } from "./AmountDetail.vue?vue&type=template&id=c1df649c&"
import script from "./AmountDetail.vue?vue&type=script&lang=ts&"
export * from "./AmountDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports